/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import * as React from 'react';

import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

import './styles.css';
import { dateFormat } from '../../../core/utils/dateFormat';
import { OrderCode } from '../OrderCode';
import TagStatus from '../TagStatus';

const Root = styled('div')(
  () => `
  table {
    font-family: Source Sans Pro, IBM Plex Sans, sans-serif;
    font-size: 16px/24px;
    color: #424242;
    background: #fff;
    border: 1px solid var(--color-blue-cyan);
    border-collapse: collapse;
    width: 100%;
    overflow: hidden;
    border-radius: 10px;
  }

  th {
    border: 0px 1px solid var(--color-blue-cyan);
    text-align: left;
    padding: 15px;
    background-color: var(--color-white);
  }
  td {
    text-align: left;
    padding: 15px;
    background-color: var(--color-white);
    
  }
  tr {
    border: 1px solid var(--color-blue-cyan);
    text-align: left;
    padding: 15px;
    background-color: var(--color-white);
  }
  td:last-child {
    width: 120px;
  }
  `,
);

export default function Table({
  dataRows,
  columns,
  onClick,
  handleSetPageOrderList,
  totalOrders,
  changeRowPerPage,
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataRows.length) : 0;

  const handleChangePage = async (event, newPage) => {
    setPage(0);
    await handleSetPageOrderList((newPage - 1) * rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeRowPerPage(parseInt(event.target.value, 10));
  };

  const handleOnClick = (id) => {
    onClick(id);
  };

  return (
    <Root sx={{ width: '100%', maxWidth: '100%' }}>
      <table id="table" aria-label="custom pagination table">
        <thead>
          <tr>
            {columns.map((item) => (
              <th key={`${item.value}-${Math.random()}`}>{item.value}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(rowsPerPage > 0
            ? dataRows.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
              )
            : dataRows
          ).map((order) => (
            <tr
              key={order.id}
              id="row-table"
              onClick={() => handleOnClick(order.id)}
            >
              {columns.map((column) => (
                <td key={`${column.key}-${order.id}`}>
                  {column.key !== 'status' ? (
                    column.key === 'updated_at' ||
                    column.key === 'created_at' ||
                    column.key === 'orderDate' ? (
                      <div id="column-order">
                        {dateFormat(order[column.key])}
                      </div>
                    ) : column.key === 'code' ? (
                      <OrderCode
                        code={order[column.key]}
                        storeName={order.store}
                      />
                    ) : (
                      <div id="column-order">{order[column.key]}</div>
                    )
                  ) : (
                    <TagStatus
                      key={`${column.key}-${order.id}tag`}
                      status={order[column.key].name}
                      label={order[column.key].name}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}

          {emptyRows > 0 && (
            <tr style={{ height: 41 * emptyRows }}>
              <td colSpan={3} />
            </tr>
          )}
        </tbody>
      </table>
      <div className="footer-table">
        <label>{`Mostrando ${rowsPerPage} de ${totalOrders} resultados`}</label>

        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
        >
          <MenuItem key="5" value={5}>
            Exibir de 5 em 5
          </MenuItem>
          <MenuItem key="10" value={10}>
            Exibir de 10 em 10
          </MenuItem>
          <MenuItem key="25" value={25}>
            Exibir de 25 em 25
          </MenuItem>
          <MenuItem key="todos" value={totalOrders}>
            Exibir todos
          </MenuItem>
        </Select>

        <Stack>
          <Pagination
            count={Math.ceil(totalOrders / rowsPerPage)}
            shape="rounded"
            color="primary"
            onChange={async (event, page) => {
              await handleChangePage(event, page);
            }}
          />
        </Stack>
      </div>
    </Root>
  );
}

Table.propTypes = {
  dataRows: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  columns: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  onClick: PropTypes.func.isRequired,
  handleSetPageOrderList: PropTypes.func.isRequired,
  totalOrders: PropTypes.number.isRequired,
  changeRowPerPage: PropTypes.func.isRequired,
};
